const charMap: Record<string, string> = {
    // Cyrillic
    А: 'A',
    а: 'a',
    В: 'B',
    Е: 'E',
    е: 'e',
    К: 'K',
    к: 'k',
    М: 'M',
    Н: 'H',
    О: 'O',
    о: 'o',
    Р: 'P',
    р: 'p',
    С: 'C',
    с: 'c',
    Т: 'T',
    У: 'Y',
    у: 'y',
    Х: 'X',
    х: 'x',
    І: 'I',

    // Greek
    Α: 'A',
    α: 'a',
    Β: 'B',
    ϲ: 'c',
    Ε: 'E',
    ε: 'e',
    Κ: 'K',
    κ: 'k',
    Μ: 'M',
    Ν: 'N',
    Ο: 'O',
    ο: 'o',
    Ρ: 'P',
    ρ: 'p',
    Σ: 'S',
    σ: 's',
    ς: 's',
    Τ: 'T',
    Υ: 'Y',
    υ: 'y',
    Χ: 'X',
    χ: 'x'
};

export function normaliseObjectId(str: string): string {
    return str
        .normalize('NFC')
        .split('')
        .map((ch) => charMap[ch] || ch)
        .join('');
}
